import { Meteor } from 'meteor/meteor';
import { Roles } from 'meteor/alanning:roles';
import { isNil } from 'lodash';

import { getUserName, getEmailAddress, isEmailVerified } from '../../api/Users/user-operations';

export function onLogin() {
  return dispatch => {
    const loggingIn = Meteor.loggingIn();
    const user = Meteor.user();
    const userId = Meteor.userId();
    if (!isNil(user)) {
      const name = getUserName(user);
      const emailAddress = getEmailAddress(user);
      const emailVerified = isEmailVerified(user);

      dispatch({
        type: 'ON_LOGIN',
        loading: false,
        loggingIn,
        authenticated: !loggingIn && !!userId,
        name: name || emailAddress,
        roles: Roles.getRolesForUser(userId),
        isAdmin: Roles.userIsInRole(userId, 'admin'),
        isPremium: Roles.userIsInRole(userId, 'premium-user'),
        userId,
        emailAddress,
        emailVerified
      });
    }
  };
}

export function onLogout() {
  return dispatch => {
    dispatch({
      type: 'ON_LOGOUT',
      loading: false,
      loggingIn: false,
      authenticated: false,
      name: '',
      roles: [],
      isAdmin: false,
      isPremium: false,
      userId: null,
      emailAddress: '',
      emailVerified: false
    });
  };
}
